import {inject, Injectable} from "@angular/core";
import {DateWrapper} from "src/app/domain/domain-models";
import {DataStorageService} from "src/app/infrastructure/data-storage.service";
import {RefreshStore} from "src/app/infrastructure/init/refresh/refresh.store";
import {isEqualToOrOlderThanOffset} from "src/app/app.config";
import {tenMinutes} from "src/app/presentation/common/globals";

@Injectable({
  providedIn: 'root'
})
export class RefreshService {

  private refreshStore = inject(RefreshStore);

  constructor(
    private dataStorageService: DataStorageService
  ) {}

  recordRefresh() {
    const now = new Date().toISOString();
    this.dataStorageService.addKeyValuePair<DateWrapper>('lastRefresh', { date: now });
    this.refreshStore.setLastRefresh(now);
  }

  async shouldRefresh() {
    const lastRefresh = await this.dataStorageService.getValueByKey<DateWrapper>('lastRefresh');
    return !lastRefresh || isEqualToOrOlderThanOffset(new Date(lastRefresh.date), tenMinutes);
  }
}
